<template>
  <div class="details-pictures-container">
    <div class="scrollable-content">
      <div v-if="isDesktop">
        <ProductImage
          v-if="selectedImage === 'product'"
          class="border-circle"
          :showBackground="true"
          :showOnlyBottomBackground="false"
          :noOverflowShadow="true"
          :language="this.$store.getters.language"
          :personalName="this.$store.getters.name"
          :colorLabel="this.$store.getters.labelColor"
          :colorCapsule="this.$store.getters.capsuleColor"
          :hide-small="false"
          :pattern="this.$store.getters.labelPattern"
          square
        >
        </ProductImage>
        <img
          v-else-if="selectedImage !== 'product'"
          :src="selectedImage"
          class="large-image border-circle"
        />
      </div>
      <div v-else class="carousel-container">
        <!-- Bildanzeige -->
        <div class="image-wrapper-2">
          <ProductImage
            v-if="images2[currentIndex] === 'product'"
            class="border-circle"
            :showBackground="true"
            :showOnlyBottomBackground="false"
            :noOverflowShadow="true"
            :language="this.$store.getters.language"
            :personalName="this.$store.getters.name"
            :colorLabel="this.$store.getters.labelColor"
            :colorCapsule="this.$store.getters.capsuleColor"
            :hide-small="false"
            :pattern="this.$store.getters.labelPattern"
            square
          ></ProductImage>

          <img v-else :src="images2[currentIndex]" class="carousel-image" />
        </div>

        <!-- Navigation mit Pfeilen und Bildzähler -->
        <div class="carousel-navigation">
          <button @click="prevImage" class="carousel-arrow">
            <img src="/arrows/open.svg" alt="left" class="arrowleft" />
          </button>
          <span class="image-counter">
            {{ currentIndex + 1 }} / {{ images2.length }}
          </span>
          <button @click="nextImage" class="carousel-arrow">
            <img src="/arrows/open.svg" alt="left" class="arrowright" />
          </button>
        </div>
      </div>
      <div class="pictures-below-can">
        <div
          class="picture-below-can"
          :class="{ active: selectedImage === 'product' }"
          @click="selectImage('product')"
        >
          <div class="product-image-wrapper">
            <ProductImage
              class="product-image-small"
              :showBackground="true"
              :showOnlyBottomBackground="false"
              :noOverflowShadow="true"
              :language="this.$store.getters.language"
              :personalName="this.$store.getters.name"
              :colorLabel="this.$store.getters.labelColor"
              :colorCapsule="this.$store.getters.capsuleColor"
              :hide-small="false"
              :pattern="this.$store.getters.labelPattern"
              square
            ></ProductImage>
          </div>
        </div>
        <img
          v-for="(image, index) in images"
          :key="index"
          :src="image"
          class="picture-below-can"
          :class="{ active: selectedImage === image }"
          @click="selectImage(image)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductImage from "@/components/ProductImage.vue";
export default {
  name: "ProductImageCarousel",
  data() {
    return {
      // Die Standardauswahl, die zuerst oben angezeigt wird
      selectedImage: "product",
      // Eine Liste mit Bildpfaden (diese kannst du anpassen)
      images: [
        "/assets/IMG_5189-2.jpg",
        "/assets/Monika kann wieder lachen.jpg",
        "/assets/Fragbogen Mockup.jpg",
        "/assets/Matteo indyvit Packshot.png",
      ],
      images2: [
        "product",
        "/assets/IMG_5189-2.jpg",
        "/assets/Monika kann wieder lachen.jpg",
        "/assets/Fragbogen Mockup.jpg",
        "/assets/Matteo indyvit Packshot.png",
      ],
      currentIndex: 0,
      isDesktop: window.innerWidth > 815,
    };
  },

  computed: {
    // Liefert das aktuelle Bild (ProductImage oder URL)
    currentImage() {
      const selected = this.images2[this.currentIndex];
      if (selected === "product") {
        // Falls das aktuelle Bild das ProductImage ist, verwenden wir die URL aus dem Store
        return this.$store.getters.productImageUrl;
      }
      return selected;
    },
  },
  methods: {
    selectImage(image) {
      this.selectedImage = image;
    },
    nextImage() {
      if (this.currentIndex < this.images2.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0; // Zum ersten Bild zurück
      }
    },
    // Vorheriges Bild (Karussell)
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.images2.length - 1; // Zum letzten Bild springen
      }
    },
    updateDeviceType() {
      this.isDesktop = window.innerWidth > 815;
    },
  },
  mounted() {
    // Füge einen Event-Listener hinzu, um die Bildschirmgröße zu überwachen
    window.addEventListener("resize", this.updateDeviceType);
  },
  beforeUnmount() {
    // Entferne den Event-Listener beim Verlassen der Seite
    window.removeEventListener("resize", this.updateDeviceType);
  },
  components: {
    ProductImage,
  },
};
</script>

<style>
@media (min-width: 815px) {
  .details-pictures-container {
    position: relative;
    height: 100vh;
  }

  .scrollable-content {
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 0;
    height: 100vh;
    right: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 120px;
  }

  .scrollable-content::-webkit-scrollbar {
    width: 12px;
  }

  .scrollable-content::-webkit-scrollbar-track {
    background: transparent;
  }

  .scrollable-content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
}

.arrowleft {
  transform: rotate(90deg);
  width: 20px;
}

.arrowright {
  transform: rotate(-90deg);
  width: 20px;
}

.carousel-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.carousel-image {
  width: 100%;
  margin-top: 50px;
  border-radius: 30px;
  object-fit: contain;
}

.carousel-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.carousel-arrow {
  background-color: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0 0;
}

.image-counter {
  margin: 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.large-image {
  width: 100%;
  height: auto;
  max-height: 700px; /* Passe die maximale Größe des großen Bildes an */
  border-radius: 999px;
  object-fit: cover;
}
@media (max-width: 815px) {
  .pictures-below-can {
    display: none !important;
  }
}

.pictures-below-can {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}

/* @media (max-width: 815px) {
  .pictures-below-can {
    width: 100px;
    height: 100px;
  }
} */

.picture-below-can {
  width: 160px;
  height: 160px;
  border-radius: 30px;
  overflow: hidden;
  cursor: pointer;
  display: flex; /* Wichtig für Zentrierung */
  justify-content: center;
  align-items: center;
  object-fit: cover;
}

.image-wrapper-2 {
  width: 100%;
}

.product-image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.product-image-small {
  object-fit: cover;
  border-radius: 30px;
  transform: scale(0.26);
  min-width: 700px;
}
@media (max-width: 815px) {
  .product-image-small {
    min-width: 100%;
    object-fit: cover;
    border-radius: 30px;
    transform: scale(0.3);
    min-width: 900px;
  }
}

.border-circle {
  border: 1px solid #ccc;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  min-width: 300px;
}

@media only screen and (max-width: 990px) {
  .product-image {
    min-width: 100%;
    margin-top: -40px;
  }
}

@media (min-width: 1400px) {
  .border-circle {
    min-width: 700px;
  }
}

/* @media only screen and (min-width: 991px) {
  .product-image {
    min-width: calc(50% + 50px);
    margin-right: -50px; 
  }
} */

.picture-below-can img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.picture-below-can.active {
  border: 3px solid #000;
}
</style>
